interface CategoriesToolsProps {
	category_key: string;
	category_name: string;
	tool: string | null;
	name: string | null;
}

type Result = {
	id: string;
	risk: RiskLibertyMutual | string;
};

type RiskLibertyMutual = {
	male_score: string;
	female_score: string;
};

export type RelatedReport = {
	name: string;
	result: Result;
};

export const CATEGORIES_TOOLS: CategoriesToolsProps[] = [
	{
		category_key: 'lift_and_lower',
		category_name: 'Lift and lower',
		tool: 'niosh',
		name: 'NIOSH / ISO 11228-1'
	},
	{
		category_key: 'push_pull',
		category_name: 'Push / pull',
		tool: 'kim_pp',
		name: 'KIM PUSH PULL'
	},
	{
		category_key: 'transport',
		category_name: 'Transport',
		tool: 'liberty_mutual',
		name: 'LIBERTY MUTUAL'
	},
	{
		category_key: 'repetitive_movements',
		category_name: 'Repetitive movements',
		tool: 'strain_index',
		name: 'STRAIN INDEX'
	},
	{
		category_key: 'forced_posture',
		category_name: 'Forced posture',
		tool: 'reba',
		name: 'REBA'
	},
	{
		category_key: 'hand_arm_vibration',
		category_name: 'Hand-arm vibration',
		tool: 'jds_d86',
		name: 'JDS-D86'
	},
	{
		category_key: 'whole_body_vibration',
		category_name: 'Whole body vibration',
		tool: 'jds_d86',
		name: 'JDS-D86'
	},
	{
		category_key: 'thermal_comfort',
		category_name: 'Thermal comfort',
		tool: null,
		name: null
	},
	{
		category_key: 'contact_stress',
		category_name: 'Contact stress',
		tool: null,
		name: null
	},
	{
		category_key: 'standing',
		category_name: 'Standing',
		tool: null,
		name: null
	}
];
